"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalloutOffsetStyles = exports.getCalloutStyles = exports.getStyles = void 0;
var Styling_1 = require("../../Styling");
var getStyles = function (props) {
    var _a;
    var theme = props.theme, disabled = props.disabled, visible = props.visible;
    return {
        container: [
            {
                backgroundColor: theme.palette.neutralDark,
            },
            disabled && {
                opacity: 0.5,
                selectors: (_a = {},
                    _a[Styling_1.HighContrastSelector] = {
                        color: 'GrayText',
                        opacity: 1,
                    },
                    _a),
            },
            !visible && {
                visibility: 'hidden',
            },
        ],
        root: [
            theme.fonts.medium,
            {
                textAlign: 'center',
                paddingLeft: '3px',
                paddingRight: '3px',
                backgroundColor: theme.palette.neutralDark,
                color: theme.palette.neutralLight,
                minWidth: '11px',
                lineHeight: '17px',
                height: '17px',
                display: 'inline-block',
            },
            disabled && {
                color: theme.palette.neutralTertiaryAlt,
            },
        ],
    };
};
exports.getStyles = getStyles;
var getCalloutStyles = function (props) {
    return {
        container: [],
        root: [
            {
                border: 'none',
                boxShadow: 'none',
            },
        ],
        beak: [],
        beakCurtain: [],
        calloutMain: [
            {
                backgroundColor: 'transparent',
            },
        ],
    };
};
exports.getCalloutStyles = getCalloutStyles;
var getCalloutOffsetStyles = function (offset) {
    return function (props) {
        return (0, Styling_1.mergeStyleSets)((0, exports.getCalloutStyles)(props), {
            root: [
                {
                    // eslint-disable-next-line @typescript-eslint/no-deprecated
                    marginLeft: offset.left || offset.x,
                    // eslint-disable-next-line @typescript-eslint/no-deprecated
                    marginTop: offset.top || offset.y,
                },
            ],
        });
    };
};
exports.getCalloutOffsetStyles = getCalloutOffsetStyles;
//# sourceMappingURL=Keytip.styles.js.map